import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Drawer,
  MenuItem,
  Typography,
} from '@material-ui/core';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';
import { apiActions } from 'app/core/api/api-redux';
import {
  currencyCodes,
  mapCurrencyCodeToSymbol,
} from 'app/core/api/product-assignment/api-product-assignment.types';
import {
  // BankStatus,
  ChatEventType,
  CurrencyObject,
  EventEntity,
  RepairCase,
  SendChatData,
} from 'app/core/api/repairer/api-repairer.types';
import { defaultEventSendType } from 'app/core/api/user/user-utils';
import SelectInput from 'app/shared/components/form-input/SelectInput';
import TextInput from 'app/shared/components/form-input/TextInput';
import Icon from 'app/shared/components/icon/Icon';
import IconLib from 'app/shared/components/icon/icon-lib';
// import Body from 'app/shared/components/typography/body/Body';
import { useShowInfo } from 'app/shared/context-hooks/use-show-info.hook';
import MultiPartInputBox from 'app/shared/frames/MultiPartInputBox';
import _ from 'lodash';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components/macro';
import {
  useCreateRepairEvent,
  // useGetBankStatus,
} from 'app/core/api/repairer/api-repairer';
// import { appEnv, AppVariant } from 'app/core/environment';
// import useInputForm from 'app/shared/components/form-input/utilities/use-input-form';
// import { useEffectOnChanges } from 'app/tools/hooks/misc-hooks';
// import { useHistory } from 'react-router-dom';
// import BusinessRoutePath from 'app/business-app/BusinessRoutePath';
import { EMPTY_MESSAGE } from './chat-utils';

type QuoteValue = {
  description: string;
  qty: number;
  currency: string;
  total: number;
};

type DiaQuoteValue = {
  currency: string | unknown;
  amount: number | unknown;
};

type Props = {
  isQuoteCreateOpen: boolean;
  setIsQuoteCreateOpen: (isVisible: boolean) => unknown;
  repairCase: RepairCase | undefined;
  refreshRepairCase: () => unknown;
  showDiagnosisQuote?: boolean | unknown;
};

const QuoteContainer = styled.div`
  display: flex;
`;
const Hr = styled.hr`
  width: 100%;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.161);
  border: 1px solid #eaeaea;
`;
const StyledAccordion = styled(Accordion)`
  border: none;
  outline: none;
  box-shadow: none;
  width: 90%;
  border: 1px solid #eaeaea;
  border-radius: 10px;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.161);
  margin: 20px auto !important;
`;
const StyledAccordionSumm = styled(AccordionSummary)`
  height: 57px;
`;

export default function CreateQuote({
  isQuoteCreateOpen,
  setIsQuoteCreateOpen,
  repairCase,
  refreshRepairCase,
  showDiagnosisQuote,
}: Props): JSX.Element {
  const dispatch = useDispatch();
  const { showSnack } = useShowInfo();
  // const history = useHistory();

  const { request$: createRepairEvent$ } = useCreateRepairEvent();

  // const { resource: bankDetails } = useGetBankStatus({ fresh: true });
  // useEffectOnChanges(
  //   sendQuote => {
  //     if (bankDetails) {
  //       showDialog({
  //         title: 'Incomplete Bank Details',
  //         message:
  //           'To be able to issue this quote, you must first complete filling in your bank details',
  //         actions: [
  //           {
  //             text: 'Fill in bank details',
  //             callback: () => {
  //               history.push(`${BusinessRoutePath.PAYMENT}`);
  //             },
  //           },
  //         ],
  //       });
  //     } else {
  //       sendQuote();
  //     }
  //   },
  //   [showDialog, bankDetails, history]
  // );

  // const isConsumer = appEnv.APP_VARIANT === AppVariant.CONSUMER;
  const sendQuote = (
    type: string,
    diagnosticQuotes?: DiaQuoteValue,
    quotes?: QuoteValue[]
  ) => {
    if (type === 'repair') {
      let amountTemp = quotes
        ?.map(item => item.total * item.qty)
        .reduce((prev, curr) => prev + curr, 0);

      if (!Number.isInteger(amountTemp)) {
        amountTemp = Number(amountTemp?.toFixed(2) ?? 0);
      }
      const amount = amountTemp;

      const eventData: SendChatData[] = [
        {
          displayText: `The price for repair will be £${String(
            amount ?? 0
          )}. Are you happy to proceed?`,
          eventType: ChatEventType.REPAIR_QUOTE,
          actionData: {
            quoteDetails: quotes,
            quotationAmount: {
              amount: Number(amount ?? 0),
              currency: 'GBP',
            },
          },
        },
      ];
      if (!repairCase) return;
      const tempEvents: EventEntity[] = eventData.map(
        ({ displayText, eventType, image }) => ({
          displayText: image ? EMPTY_MESSAGE : displayText,
          eventType: eventType || defaultEventSendType,
          // negative id denotes temporary message to be displayed in pale format
          id: _.random(-9999999, -1000000, false),
          repairCase: repairCase.id,
          imageUrl: image ? URL.createObjectURL(image) : undefined,
        })
      );
      const { events: chatEvents = [] } = repairCase || {};

      dispatch(
        apiActions.repairCase.set({
          ...repairCase,
          events: [...chatEvents, ...tempEvents],
        })
      );
      const caseIdObj = { repairCase: +repairCase.id };
      const sendChatData = {
        displayText: `The price for repair will be £${String(
          amount ?? 0
        )}. Are you happy to proceed?`,
        eventType: ChatEventType.REPAIR_QUOTE,
        actionData: {
          quoteDetails: quotes,
          quotationAmount: {
            amount: Number(amount ?? 0),
            currency: 'GBP',
          },
        },
      };
      const messageSentObserver = {
        next: refreshRepairCase,
        error: () =>
          showSnack({
            message: 'Something went wrong! Please try again.',
          }),
      };
      createRepairEvent$({
        ...caseIdObj,
        ...sendChatData,
      }).subscribe(messageSentObserver);
      setIsQuoteCreateOpen(false);
    } else {
      const eventData: SendChatData[] = [
        {
          displayText: `The price for diagnosis will be £${String(
            diagnosticQuotes?.amount ?? 0
          )}. Are you happy to proceed?`,
          eventType: ChatEventType.DIAGNOSIS_QUOTE,
          actionData: {
            quotationAmount: {
              amount: Number(diagnosticQuotes?.amount ?? 0),
              currency: String(diagnosticQuotes?.currency ?? ''),
            },
          },
        },
      ];
      if (!repairCase) return;
      const tempEvents: EventEntity[] = eventData.map(
        ({ displayText, eventType, image }) => ({
          displayText: image ? EMPTY_MESSAGE : displayText,
          eventType: eventType || defaultEventSendType,
          // negative id denotes temporary message to be displayed in pale format
          id: _.random(-9999999, -1000000, false),
          repairCase: repairCase.id,
          imageUrl: image ? URL.createObjectURL(image) : undefined,
        })
      );
      const { events: chatEvents = [] } = repairCase || {};

      dispatch(
        apiActions.repairCase.set({
          ...repairCase,
          events: [...chatEvents, ...tempEvents],
        })
      );
      const caseIdObj = { repairCase: +repairCase.id };
      const sendChatData = {
        displayText: `The price for diagnosis will be £${String(
          diagnosticQuotes?.amount ?? 0
        )}. Are you happy to proceed?`,
        eventType: ChatEventType.DIAGNOSIS_QUOTE,
        actionData: {
          quotationAmount: {
            amount: Number(diagnosticQuotes?.amount ?? 0),
            currency: String(diagnosticQuotes?.currency ?? ''),
          },
        },
      };
      const messageSentObserver = {
        next: refreshRepairCase,
        error: () =>
          showSnack({
            message: 'Something went wrong! Please try again.',
          }),
      };
      createRepairEvent$({ ...caseIdObj, ...sendChatData }).subscribe(
        messageSentObserver
      );
      setIsQuoteCreateOpen(false);
    }
  };
  const DialogMessage: React.VFC<{
    modifiableCurrencyObject: Partial<CurrencyObject>;
  }> = ({ modifiableCurrencyObject }) => {
    const [diagnosticQuotes, setDiagnosticQuotes] =
      useState<DiaQuoteValue>({
        currency: 'GBP',
        amount: 0,
      });
    return (
      <Box display="flex" flexDirection="column">
        {/* <Body>Enter your quote below</Body> */}
        <Box height="10px" />
        <MultiPartInputBox variant="flush" gridCols="6em 1fr">
          <SelectInput
            defaultValue="GBP"
            minHeight={45}
            value={diagnosticQuotes.currency}
            onChange={e => {
              // eslint-disable-next-line no-param-reassign
              modifiableCurrencyObject.currency = String(
                e.target.value
              );
              setDiagnosticQuotes({
                ...diagnosticQuotes,
                currency: e.target.value ?? '',
              });
            }}
          >
            {_.keys(currencyCodes).map(code => (
              <MenuItem value={code} key={code}>
                {mapCurrencyCodeToSymbol.get(code)}
              </MenuItem>
            ))}
          </SelectInput>
          <TextInput
            greyPlaceholder
            minHeight={45}
            placeholder="0.00"
            label="Price"
            type="number"
            value={diagnosticQuotes.amount}
            onChange={e => {
              // eslint-disable-next-line no-param-reassign
              // modifiableCurrencyObject.amount = Number(e.target.value);
              setDiagnosticQuotes({
                ...diagnosticQuotes,
                amount: e.target.value,
              });
            }}
          />
        </MultiPartInputBox>
        <div style={{ textAlign: 'right' }}>
          <button
            onClick={() => sendQuote('diagnostic', diagnosticQuotes)}
            type="button"
            style={{
              background: 'none',
              color: '#31AD31',
              border: 'none',
              padding: 0,
              font: 'inherit',
              cursor: 'pointer',
              outline: 'inherit',
            }}
          >
            Send quote
          </button>{' '}
          &nbsp;
          <button
            onClick={() => setIsQuoteCreateOpen(false)}
            type="button"
            style={{
              background: 'none',
              color: 'red',
              border: 'none',
              padding: 0,
              font: 'inherit',
              cursor: 'pointer',
              outline: 'inherit',
            }}
          >
            Cancel
          </button>
        </div>
      </Box>
    );
  };
  const RepairQuote: React.VFC<{
    modifiableCurrencyObject: Partial<CurrencyObject>;
  }> = () => {
    const [quotes, setQuote] = useState<QuoteValue[]>([
      { description: '', qty: 1, currency: 'GBP', total: 0 },
    ]);
    const AddNewArray = () => {
      const newStateArray: QuoteValue = {
        description: '',
        qty: 0,
        currency: 'GBP',
        total: 0,
      };
      setQuote([...quotes, newStateArray]);
    };
    return (
      <Box display="flex" flexDirection="column">
        {/* <Body>Enter your quote below</Body> */}
        <Box height="10px" />
        {quotes.map((val, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <QuoteContainer style={{ display: 'flex' }} key={index}>
            <TextInput
              greyPlaceholder
              minHeight={45}
              placeholder="Description"
              label=""
              type="string"
              style={{ margin: '3px', flex: 2 }}
              value={val.description}
              onChange={e => {
                const newTodos = [...quotes];
                newTodos[index].description = e.target.value;
                setQuote(newTodos);
              }}
            />
            <TextInput
              greyPlaceholder
              minHeight={45}
              placeholder="Qty"
              label=""
              type="number"
              style={{ margin: '3px', flex: 1 }}
              value={val.qty}
              onChange={e => {
                const newTodos = [...quotes];
                newTodos[index].qty = Number(e.target.value);
                setQuote(newTodos);
              }}
            />
            <div style={{ flex: 2 }}>
              {/* 5em 1fr */}
              <MultiPartInputBox variant="flush" gridCols="auto">
                <SelectInput
                  defaultValue="GBP"
                  minHeight={48}
                  value={val.currency}
                  onChange={e => {
                    const newTodos = [...quotes];
                    newTodos[index].currency = String(e.target.value);
                    setQuote(newTodos);
                  }}
                >
                  {_.keys(currencyCodes).map(code => (
                    <MenuItem value={code} key={code}>
                      {mapCurrencyCodeToSymbol.get(code)}
                    </MenuItem>
                  ))}
                </SelectInput>
                <TextInput
                  greyPlaceholder
                  minHeight={48}
                  placeholder="Price"
                  label=""
                  style={{ margin: '0px', flex: 1 }}
                  value={val.total}
                  type="number"
                  onChange={e => {
                    const newTodos = [...quotes];
                    newTodos[index].total = Number(e.target.value);
                    setQuote(newTodos);
                  }}
                />
              </MultiPartInputBox>
            </div>
            {/*         
            <TextInput
              greyPlaceholder
              minHeight={45}
              placeholder="Price"
              label=""
              style={{ margin: '3px', flex: 1 }}
              value={val.total}
              type="number"
              onChange={e => {
                const newTodos = [...quotes];
                newTodos[index].total = Number(e.target.value);
                setQuote(newTodos);
              }}
            /> */}
          </QuoteContainer>
        ))}
        <div>
          <button
            onClick={() => AddNewArray()}
            type="button"
            style={{
              background: 'none',
              color: 'inherit',
              border: 'none',
              padding: 0,
              font: 'inherit',
              cursor: 'pointer',
              outline: 'inherit',
            }}
          >
            <SpeedDialIcon /> Add another
          </button>
        </div>
        <div style={{ textAlign: 'right' }}>
          <button
            onClick={() => sendQuote('repair', undefined, quotes)}
            type="button"
            style={{
              background: 'none',
              color: '#31AD31',
              border: 'none',
              padding: 0,
              font: 'inherit',
              cursor: 'pointer',
              outline: 'inherit',
            }}
          >
            Send quote
          </button>{' '}
          &nbsp;
          <button
            onClick={() => setIsQuoteCreateOpen(false)}
            type="button"
            style={{
              background: 'none',
              color: 'red',
              border: 'none',
              padding: 0,
              font: 'inherit',
              cursor: 'pointer',
              outline: 'inherit',
            }}
          >
            Cancel
          </button>
        </div>
      </Box>
    );
  };
  const modifiableCurrencyObject = {
    currency: 'GBP',
  } as Partial<CurrencyObject>;
  return (
    <>
      <Drawer
        anchor="bottom"
        open={isQuoteCreateOpen}
        onClose={() => setIsQuoteCreateOpen(false)}
      >
        <h2 className="text-primary" style={{ margin: '10px auto' }}>
          Issue Quote
        </h2>
        <Hr />
        <h2 style={{ marginLeft: '5%', fontWeight: 500 }}>Quotes</h2>
        {showDiagnosisQuote !== false && (
          <StyledAccordion>
            <StyledAccordionSumm
              expandIcon={<Icon icon={IconLib.CHEVRON_DOWN} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              disabled={
                repairCase?.caseStatus === 'diagnosis_quote_issued'
              }
            >
              <Typography style={{ fontSize: '16px' }}>
                Issue diagnostic quote
              </Typography>
            </StyledAccordionSumm>
            <AccordionDetails>
              <DialogMessage {...{ modifiableCurrencyObject }} />
            </AccordionDetails>
          </StyledAccordion>
        )}
        <StyledAccordion>
          <StyledAccordionSumm
            expandIcon={<Icon icon={IconLib.CHEVRON_DOWN} />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography style={{ fontSize: '16px' }}>
              Issue repair quote
            </Typography>
          </StyledAccordionSumm>
          <AccordionDetails>
            <RepairQuote {...{ modifiableCurrencyObject }} />
          </AccordionDetails>
        </StyledAccordion>
      </Drawer>
    </>
  );
}
